export default "__VITE_ASSET__B8cAsKrU__"